import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface AppConfigState {
    cssTheme: string;
    appTitle: string;
    gatewayBaseUrl: string;
    accountingBaseUrl: string;
    formConfigBaseUrl: string;
    dropboxWsCallbackUrl: string;
    dropboxRedirectUrl: string;
    widgetDataBaseUrl: string;
    mockDataBaseUrl: string;
    nestTestApiUrl: string;
    layoutConfigurationBaseUrl: string;
    peFundBaseUrl: string;
    privateAssetBaseUrl: string;
    peFundApiKey: string;
    categoriesBaseUrl: string;
    documentsBaseUrl: string;
    adminBaseUrl: string;
    propertiesConfigurationBaseUrl: string;
    globalResourceBaseUrl: string;
    environment: string;
    bypassLogin: boolean;
    bypassRedirectUrl: string;
    basicAuthenticationHeader: string;
    buildVersion: string;
    defaultBaseCurrency: string;
    useGlobalAccountSelector: boolean;
    dropboxClientId: string;
    keycloakUrl: string;
    keycloakRealm: string;
    useLatestKeycloakFlow: boolean;
    landingPageOverride: string;
    hideRootBreadcrumb: boolean /** hide root breadcrumb from breadcrumb navigation, e.g. NAPS should not be able to go to dashboard (root) */;
    restrictDashboardChartView: 'marketValue' | 'performance' | null;
    consumerApiKey: string;
    consumerBaseUrl: string;
    clickhouseBaseUrl: string;
    securitySearchServiceUrl: string;
    useLegacyAccountList: boolean | 'balance-list';
    sharedResourceBaseUrl: string;
    dashboardNotice: false | 'newOverview';
}

export function createInitialState(): AppConfigState {
    return {
        cssTheme: 'light-theme',
        appTitle: 'Swimbird Portfolio Platform',
        gatewayBaseUrl: null,
        accountingBaseUrl: null,
        formConfigBaseUrl: null,
        widgetDataBaseUrl: null,
        mockDataBaseUrl: null,
        nestTestApiUrl: null,
        layoutConfigurationBaseUrl: null,
        peFundBaseUrl: null,
        privateAssetBaseUrl: null,
        dropboxWsCallbackUrl: null,
        dropboxRedirectUrl: null,
        peFundApiKey: null,
        categoriesBaseUrl: null,
        documentsBaseUrl: null,
        adminBaseUrl: null,
        propertiesConfigurationBaseUrl: null,
        globalResourceBaseUrl: null,
        environment: null,
        bypassLogin: null,
        bypassRedirectUrl: null,
        basicAuthenticationHeader: null,
        buildVersion: null,
        defaultBaseCurrency: 'SEK',
        useGlobalAccountSelector: false,
        dropboxClientId: null,
        restrictDashboardChartView: null,
        keycloakUrl: null,
        keycloakRealm: null,
        useLatestKeycloakFlow: false,
        consumerApiKey: null,
        consumerBaseUrl: null,
        landingPageOverride: null,
        hideRootBreadcrumb: false,
        clickhouseBaseUrl: null,
        securitySearchServiceUrl: null,
        useLegacyAccountList: false,
        sharedResourceBaseUrl: null,
        dashboardNotice: false
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'appConfig' })
export class AppConfigStore extends Store<AppConfigState> {
    constructor() {
        super(createInitialState());
    }
}
